import React from 'react';
import moment from 'moment';
import NumberFormat from 'components/NumberFormat';

import './TicketsWidget.scss';
import { METHODS_LABELS } from '../../../utils/Consts';

function TicketsWidget({ reserves, authUser }) {

  if (!reserves || !reserves.length || !authUser) return '';

  return (
    <div className="tickets-widget">
      <h1>Meus ingressos</h1>
      {reserves.map(reserve => 
      (authUser.email === reserve.email || authUser.pk_user === reserve.fk_user) && (
          <div key={reserve.pk_reserve} className="ticket">
            <div className="ticket-header">
              <div>
                <strong>Código: {reserve.pk_reserve}</strong>
                <span>Compra realizada em {moment(reserve.created_at).format("DD/MM/YYYY HH:mm")}</span>
              </div>
              <p>{reserve.packageName}</p>
              {/* <a href={reserve.pdf_url} rel="noopener noreferrer" target="_blank">
                <Icon>save_alt</Icon> Baixar PDF
              </a> */}
            </div>
            <div className="ticket-body">
              <div className="ticket-participant">
                <strong>Participante</strong>
                <div className="ticket-content">
                  <div>
                    <span>Nome*:</span>
                    <p>{reserve.name}</p>
                  </div>
                  <div>
                    <span>Telefone:</span>
                    <p>{reserve.phone}</p>
                  </div>
                  <div>
                    <span>Email:</span>
                    <p>{reserve.email}</p>
                  </div>
                  {reserve.custom_fields.map((field) => 
                  <div>
                    <span>{field.title}</span>
                    <p>{field.value}</p>
                  </div>
                  )}
                </div>
              </div>
              <div className="ticket-payment">
                <strong>Pagamento</strong>
                <div className="ticket-content">
                  <div>
                    <span>Valor pago:</span>
                    <p>{Number(reserve.payment.price).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
                  </div>
                  <div>
                    <span>Data de pagamento:</span>
                    <p>{moment(reserve.payment.created_at).format("DD/MM/YYYY HH:mm")}</p>
                  </div>
                  {/* <div>
                    <span>Pagante:</span>
                    <p>{reserve.payment.user.name}</p>
                  </div>
                  <div>
                    <span>Telefone:</span>
                    <p>{reserve.payment.user.phone}</p>
                  </div> */}
                  <div>
                    <span>Meio de pagamento:</span>
                    <p>{METHODS_LABELS[reserve.payment.method]}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}

    </div>
  );
}

export default TicketsWidget;